import React, { useEffect } from 'react';
import { getMessage } from 'util/locale';
import propTypes from 'prop-types';
import classNames from 'classnames';

// components
import FertilizerProductInputsContainerConnected from 'products/FertilizerProductInputsContainer';
import Nitrapyrin from 'products/Nitrapyrin';
import SubstanceType from 'products/SubstanceType';
import ScriptName from 'common/ScriptName';

const baseString = 'vra-script-config-inputs';
const classString = classNames({
  [`${baseString}`]: true
});
const titleClassString = classNames({
  [`${baseString}__header`]: true,
  'vra-script-config-inputs__header': true
});
const ScriptConfigFertilityInputs = ({
  displayScriptName,
  hasNitrapyrin,
  onChangeNitrapyrin,
  onChangeScriptName,
  onFertilityInputMount,
  onSelectFertilizerProduct,
  onSelectSubstanceType,
  substanceTypeIsNitrogen,
  substanceTypes,
  substanceTypeUuid,
  validationResult
}) => {
  useEffect(() => {
    onFertilityInputMount();
  }, []);

  return (
    <section className={classString}>
      <header className={titleClassString}>{getMessage('title-text__script-config')}</header>
      <ScriptName
        displayScriptName={displayScriptName}
        onChange={onChangeScriptName}
        validationResult={validationResult}
      />
      <SubstanceType
        onSelectSubstanceType={onSelectSubstanceType}
        selected={substanceTypeUuid}
        substanceTypes={substanceTypes}
      />
      <FertilizerProductInputsContainerConnected 
        onSelectFertilizerProduct={() => onSelectFertilizerProduct(substanceTypeUuid)} 
        substanceTypeUuid={substanceTypeUuid} 
      />
      {
        substanceTypeIsNitrogen
        && (
          <section className={`${baseString}__nitrogen-inputs`}>
            <Nitrapyrin
              onChange={onChangeNitrapyrin}
              selected={hasNitrapyrin}
            />
          </section>
        )
      }
    </section>
  );
};

ScriptConfigFertilityInputs.propTypes = {
  displayScriptName: propTypes.string.isRequired,
  hasNitrapyrin: propTypes.bool.isRequired,
  onChangeNitrapyrin: propTypes.func.isRequired,
  onChangeScriptName: propTypes.func.isRequired,
  onFertilityInputMount: propTypes.func.isRequired,
  onSelectFertilizerProduct: propTypes.func.isRequired,
  onSelectSubstanceType: propTypes.func.isRequired,
  substanceTypeIsNitrogen: propTypes.bool.isRequired,
  substanceTypeUuid: propTypes.string,
  substanceTypes: propTypes.object.isRequired,
  validationResult: propTypes.object
};
export default ScriptConfigFertilityInputs;
